import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Pricing from '../../components/Pricing/Pricing';
import Footer from '../../components/Footer/Footer';
import '../MarketingDetailPage.scss';

const PricingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="marketing-detail-page">
      <Helmet>
        <title>요금제 - 매쓰테일러 PDF HWP 변환 · 수학 AI 플랫폼</title>
        <meta name="description" content="매쓰테일러의 PDF HWP 변환과 나만의 문제은행 구축 요금을 확인하세요. 단원관리, 문제출제, 시험지 저장과 HWP·PDF 프린트를 지원합니다." />
        <meta name="keywords" content="매쓰테일러 요금제, 나만의 문제은행 구축 가격, HWP 문제은행, 수학 문제은행, PDF HWP 변환 가격, 수학 AI 플랜" />
        <meta property="og:title" content="요금제 - 매쓰테일러" />
        <meta property="og:description" content="PDF HWP 변환과 나만의 문제은행 구축을 위한 매쓰테일러 요금 안내입니다." />
        <meta property="og:url" content="https://xn--vl2b19ao0ssqc39r.kr/pricing" />
      </Helmet>
      <Pricing />
      <Footer />
    </main>
  );
};

export default PricingPage;
